import { createContext } from 'react';
import { Preferences } from './types';

export const PreferencesContext = createContext<Preferences>({} as Preferences);
PreferencesContext.displayName = 'UserPreferences';
